import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../../../../app/actions/generalActions";
import { useObjectsUIContext } from "../ObjectsUIContext";
import { useFilterObjectsUIContext } from "../FilterObjectsUIContext";

export function ObjectsDeleteDialog({ api, show, onHide, currentState, softDelete }) {
  const objectsUIContext = useObjectsUIContext();
  const filterUIContext = useFilterObjectsUIContext();

  const objectsUIProps = useMemo(() => {
    return {
      ids: objectsUIContext.ids,
      setIds: objectsUIContext.setIds,
      queryParams: filterUIContext.queryParams,
    };
  }, [objectsUIContext, filterUIContext]);

  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: currentState.actionsLoading }),
    shallowEqual
  );

  const { name } = currentState;

  useEffect(() => { }, [isLoading, dispatch]);

  useEffect(() => {
    if (!objectsUIProps.ids || objectsUIProps.ids.length === 0) {
      onHide();
    }

  }, [objectsUIProps.ids]);

  const deleteObjects = () => {
    dispatch(actions.deleteObjects(api, name, objectsUIProps.ids, softDelete)).then(() => {
      dispatch(actions.fetchObjects(api, name, objectsUIProps.queryParams)).then(() => {
        objectsUIProps.setIds([]);
        onHide();


      });
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          غیرفعالسازی چند تایی
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>آیا از غیرفعالسازی موارد انتخاب شده اطمینان دارید ؟</span>
        )}
        {isLoading && <span>در حال غیرفعالسازی ...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            انصراف
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteObjects}
            className="btn btn-primary btn-elevate"
          >
            حذف همه
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
